import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/lib/translations";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-black border-t border-white/5 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={COMPANY.logo}
              alt="Faustitur"
              className="h-12 w-12 object-cover rounded-sm border border-white/10"
            />
            <div className="leading-tight">
              <p className="font-display text-xl text-white">Faustitur</p>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--teal)]">
                Tourism Taxi
              </p>
            </div>
          </div>
          <p className="mt-4 text-sm text-zinc-400 max-w-xs">{t.footer.tagline}</p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={COMPANY.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="social-icon"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={COMPANY.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="social-icon"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
            {t.nav.services}
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href="#services" className="text-zinc-300 hover:text-[color:var(--gold)]">
                {t.footer.links.services}
              </a>
            </li>
            <li>
              <a href="#tours" className="text-zinc-300 hover:text-[color:var(--gold)]">
                {t.footer.links.tours}
              </a>
            </li>
            <li>
              <a href="#booking" className="text-zinc-300 hover:text-[color:var(--gold)]">
                {t.footer.links.booking}
              </a>
            </li>
            <li>
              <a href="#contact" className="text-zinc-300 hover:text-[color:var(--gold)]">
                {t.footer.links.contact}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
            {t.nav.contact}
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href={COMPANY.telLink}
                data-testid="footer-phone"
                className="text-zinc-200 hover:text-[color:var(--gold)]"
              >
                {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={COMPANY.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="text-zinc-200 hover:text-[color:var(--whatsapp)]"
              >
                WhatsApp · {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="text-zinc-200 hover:text-[color:var(--gold)] break-all"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="text-zinc-400">{COMPANY.base}</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-zinc-500">
          © {year} Faustitur — Táxi de Turismo, Lda. {t.footer.rights}
        </p>
        <div className="flex items-center gap-5">
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-[color:var(--gold)] transition-colors"
          >
            {t.footer.admin}
          </a>
          <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-600">
            Licensed · Portimão
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
